import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { FeedProduct } from '@vestiaire/api-sdk-angular';
import { environment } from '@env/environment';
import { ImagesService } from '@app/shared/components/images/services/images.service';

@Component({
  selector: 'vc-feed-product',
  templateUrl: './feed-product.component.html',
  styleUrls: ['./feed-product.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeedProductComponent {
  @Input() product: FeedProduct;
  @Input() isLiked: boolean;

  @Output() likeProduct = new EventEmitter<boolean>();

  constructor(private cdr: ChangeDetectorRef) {}

  onLike($event) {
    // We update the like locally and force the component to rerender.
    // We should handle this in the store or a proper service
    // This needs architecture considerations. Also rework of backend which has 20min latency on likes.
    this.isLiked = $event;
    this.cdr.markForCheck();
    this.likeProduct.emit($event);
  }
}
